module.exports = __webpack_public_path__ + "img/dom.79f8bf8c.svg";